import {useFileDownloadUrlQuery} from '../../generated/graphql';

type UseGetFileDownloadUrlOpts = {
  entityName: string | undefined;
  projectName: string | undefined;
  runName: string | undefined;
  fileName: string | undefined;
};

export function useGetFileDownloadUrl({
  entityName,
  projectName,
  runName,
  fileName,
}: UseGetFileDownloadUrlOpts): string | null {
  const result = useFileDownloadUrlQuery({
    variables: {
      entityName,
      projectName: projectName!,
      runName: runName!,
      fileName: fileName!,
    },
    fetchPolicy: 'no-cache',
    skip: !projectName || !runName || !fileName,
  });
  return result.data?.project?.run?.files?.edges?.[0]?.node?.directUrl ?? null;
}
